import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { debounce, getTextNodesIn } from '../functions'

imagesLoaded.makeJQueryPlugin($)

let brandCategories = $('[data-brand-categories]').attr('data-brand-categories')
if (brandCategories != undefined) {
  brandCategories = brandCategories.split(',')

  let isoBrand = []

  $.each(brandCategories, function () {
    let isoBrandTemp = ''
    const parent = $('.js-container-' + this)
    if (parent.length) {
      isoBrandTemp = new Isotope('.js-container-' + this, {
        itemSelector: '.js-brands-iso-item',
        transitionDuration: 0,
      })
    }

    const search = $('.js-brands-iso-search').keyup(
        debounce(function () {
          const qsRegex = new RegExp(search.val(), 'gi')

          isoBrandTemp.arrange({
            filter: function () {
              const post = $(this)
              const text = getTextNodesIn(post[0])

              let hasText = qsRegex ? text.match(qsRegex) : true

              return hasText
            },
          })
        }, 200)
    )

    search.on('blur', function () {
      const qsRegex = new RegExp(search.val(), 'gi')

      isoBrandTemp.arrange({
        filter: function () {
          const post = $(this)
          const text = getTextNodesIn(post[0])

          let hasText = qsRegex ? text.match(qsRegex) : true

          return hasText
        },
      })
    })

    isoBrand.push(isoBrandTemp)
  })
}

let catIso = ''

const parent = $('.js-brands-iso')
if (parent.length != 0) {
  catIso = new Isotope('.js-brands-iso', {
    itemSelector: '.js-cat-iso-item',
    percentPosition: true,
    transitionDuration: 0,
    layoutMode: 'fitRows',
  })

  parent.imagesLoaded(function () {
    catIso.layout()
  })

  $('.js-brands-select').on('change', function () {
    const vals = [$('.js-brands-select').val()]

    catIso.arrange({
      filter: function () {
        const posts = $(this)

        const attr = posts.attr('data-categories')
        const categories = attr.includes(',') ? attr.split(',') : [attr]
        const newCategories = categories.map(Number)
        let hasCategory = false

        if (newCategories.length > 0) {
          for (let i = 0; i < vals.length; i++) {
            if (
                newCategories.includes(parseInt(vals[i])) ||
                vals[i] === 'all'
            ) {
              hasCategory = true
            }
          }
        }

        const post = $(this)
        const text = getTextNodesIn(post[0])
        const qsRegex = new RegExp($('.pt-brands input[type="text"]').val(), 'gi')

        let hasText = qsRegex ? text.match(qsRegex) : true

        return hasCategory && hasText
      },
    })
  })
}